// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SubCategoryBlock_wrapper__32Lcf","container":"SubCategoryBlock_container__qxel1","title":"SubCategoryBlock_title__3kKpU"};